import React, { useRef, useState }  from 'react';
import { Modal, Form, Button }      from 'react-bootstrap';
import { useDispatch }              from 'react-redux';
import clienteAxios                 from '../../../../../config/axios';

import { Formik }                   from 'formik';
import * as yup                     from 'yup';

import ButtonSpinner                from '../../../../layout/ButtonSpinner'
import { ErrorMessage }             from '../../../../extras/toastMessages';
import { ICON_SAVE, ICON_CANCEL }   from '../../../../extras/icons';
import { MOTIVO_CANCELACION }       from '../../../../../data/motivesGroups';

import { updateCancellationAction } from '../../../../../actions/audiencesActions';


const MotiveForm = props => {

    // --------------------------------------------------------------------------------------------
    // INICIALIZO ---------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    //Tomo los props
    const { audience, handleClose, setAudience, show } = props;

    //Genero los ref
    const refMotive = useRef();
    
    //Inicializo datos
    const initialData = {
        motivo: audience.motivo?.id || '',
        observacion: audience.observacionRechazo,
    }
    
    //Inicializo el dispatch
    const dispatch = useDispatch();
    
    //Inicializo el state local
    const [loading, setLoading] = useState(false);
    const [motives, setMotives] = useState([]);


    // --------------------------------------------------------------------------------------------
    // FUNCIONES ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Cargo los motivos
        loadMotives();
        //Pongo el foco en el primer campo
        refMotive.current.focus();
    }

    //Manejo el guardado
    const handleSave = values => {
        setLoading(true);
        //Armo los datos
        const data = {
            motivoId: values.motivo,
            observacion: values.observacion
        }
        //Llamo al dispatch
        dispatch( updateCancellationAction(audience, data, handleClose) );
        setAudience({
            ...audience, 
            motivo: motives.find(m => m.id === Number(values.motivo)),
            observacionRechazo: values.observacion,
        });
        setLoading(false);
    }

    //Función que cargar los motivos
    const loadMotives = async () => {
        try
        {   const response = await clienteAxios.get(`/motivo?search=activo:1&sort=descripcion:asc`);
            const audienceMotives = response.data;
            setMotives(audienceMotives.content);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            if(response)
            {   data = response.data;
            }
            ErrorMessage(data.message);
        }
    }

    //Esquema de validación
    const validationSchema = yup.object({
        motivo: yup.number().required(),
        observacion: yup.string().required(),
    });


    // --------------------------------------------------------------------------------------------
    // RENDERIZO ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    return (
        <Modal
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            onHide={handleClose} 
            onShow={handleOnShow} 
            show={show} 
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Motivo Audiencia #{ audience.id }
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                initialValues={{...initialData}}
                onSubmit={ values => handleSave(values) }
                validationSchema={validationSchema}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        Seleccione el <strong>Motivo</strong> e ingrese una <strong>observación</strong>
                                    </div>
                                </div>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        as="select"
                                        autoFocus 
                                        className="form-control" 
                                        disabled={ loading }
                                        id="motivo" 
                                        isInvalid={!!errors.motivo}
                                        name="motivo" 
                                        onChange={handleChange}
                                        ref={refMotive}
                                        type="text" 
                                        value={ values.motivo }
                                    >
                                        <option value="">Motivo...</option>
                                        {   motives.filter(m => m.grupoId === MOTIVO_CANCELACION).map(motive => (
                                                <option value={ motive.id } key={`rfm${motive.id}`}>
                                                    { motive.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.motivo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        as="textarea"
                                        className="form-control" 
                                        disabled={ loading }
                                        id="observacion"
                                        isInvalid={!!errors.observacion}
                                        name="observacion" 
                                        onChange={handleChange}
                                        placeholder="Ingrese observación"
                                        rows={5}
                                        type="text" 
                                        value={ values.observacion }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.observacion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {   loading 
                                    ?
                                        <ButtonSpinner />
                                    : 
                                        <Button disabled={loading} type="submit" variant="danger">
                                            <ICON_SAVE /> <strong>GUARDAR</strong>
                                        </Button>
                            }
                            <Button disabled={loading} onClick={handleClose} variant="secondary">
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default MotiveForm;